export const capitalize = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);
